module.exports = __webpack_public_path__ + "assets/5f3da496.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sport1.jpg
// module id = 108
// module chunks = 0